import { Button } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { CrossedCircle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSelectionDispatch } from 'modules/shift_management/hooks/useSelection'

const ClearSelectionButton = () => {
  const dispatchSelection = useSelectionDispatch()
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  const onClick = () => {
    dispatchSelection({
      type: 'CLEAR_SELECTION',
    })
  }

  return (
    <>
      {newEntryFlowEnabled ? (
        <F0Button
          variant="outline"
          onClick={onClick}
          disabled={false}
          icon={CrossedCircle}
          label={i18n.t('shift_management.clear_selection')}
        />
      ) : (
        <Button type="secondary" onClick={onClick} disabled={false} iconName="cross-circle">
          {i18n.t('shift_management.clear_selection')}
        </Button>
      )}
    </>
  )
}

export default ClearSelectionButton
